// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 524 ? "app" : chunkId) + "." + {"489":"ea3404ecb2f07a894eec","524":"626b8cb2b42c21e48d23","810":"de1ee78d2e19dc07e2e0"}[chunkId] + ".css";
};